module.exports = __webpack_public_path__ + "static/media/logo v.1e0efcad.png";